import React from "react"

import Layout from "../components/Layout"

const AvistadosPage = props => (
  <Layout>
    <h1>Registros &#128021; &#128008;</h1>
    <p>
      A tela principal do aplicativo possui quatro abas na parte inferior. Cada
      uma acessa uma função específica. O menu lateral continua acessível na
      parte superior direita (&#9776;) e você pode voltar para a tela anterior
      pelo ícone na parte superior esquerda (&lt;).
    </p>
    <p>As funções principais são:</p>
    <p>
      <ul>
        <li>
          <strong>Eventos</strong> - Você pode publicar eventos e fazer anuncios
          que serão vistos por todos os usuários. Ao publicar o aplicativo
          também enviará notificações para todos os usuários que estejam com
          notificações habilitatdas. Cada evento tem uma data de início e fim.
          Após a data de fim ele não parecerão mais na lista. A data inicial
          deve estar no máximo em 90 dias e o período de validade deve ser na
          máximo 15 dias.
        </li>
        <li>
          <strong>Resgatar</strong> - Regitrar os animais avistados como
          perdidos e que necessittam de resgate. Tirar uma foto e informar o
          maior numero possível de características físicas. Os registros de
          animais a resgatar ficam disponíveis a todos que desejarem assumir sua
          guarda colocando-os em adoção. Neste caso, eles passam para a tela de
          adoção sob novo usuário responsável.
        </li>
        <li>
          <strong>Perdidos</strong> - Regitrar animais perdidos que estão sendo
          procurados. Há uma opção de busca, que vai procurar no banco de dados
          por registros com as mesmas caracterírticas físicas.
        </li>
        <li>
          <strong>Adoção</strong> - Registrar animais para adoção. Aqui aparecem
          todos os animais colocados para adoção por todos os protetores. Eles
          aparecem também na tela de <strong>Protetores</strong>, caso tenha se
          registrado lá. O processo de adoção poderá ser feito aqui,
          identificando-se o lar de destino e os dados da pessoa que vai adotar.
        </li>
      </ul>
    </p>
    <p>
      Em todos os casos você pode utilizar a barra de busca na parte superior da
      tela para filtrar os registros por um e-mail.
    </p>
  </Layout>
)

export default AvistadosPage
